module.exports = __webpack_public_path__ + "static/media/shopify6.efcdc295.png";